<template>
	<div id="categoryPage">
		<modal name="m-filters" class="filters-modal">
			<mobile-filters :cat_id="subCategory.id"></mobile-filters>
		</modal>

		<section
			class="category_top_banner s_cat_in_top_banner cover"
			v-lazy:background-image="subCategory.thumb && false ? subCategory.thumb : mainCategory.thumb"
		>
			<div class="container" :class="{ 'white-text': mainCategory.titlebar_text_color === 'white' }">
				<h2 class="title">{{ mainCategory.name }}</h2>
				<div class="text">{{ mainCategory.description }}</div>
			</div>
			<div class="bn_corner"></div>
		</section>
		<div class="mobile_only m_cat_tabs nav-down" v-if="$mq == 'mobile'">
			<Slick class="m_cat_tabs_slide clearfix" ref="slick" :options="mSlickOptions">
				<div
					class="right m_cat_tab"
					v-for="subcat in subCategories"
          v-bind:class="{ active: subcat.id == subCategory.id }"
					:key="subcat.id"
					:index="subcat.id"
				>
					<router-link :to="{ path: subcat.link }" v-bind:data-subid="subcat.id">
						<span class="table100">
							<span class="table_cell">{{ subcat.name }}</span>
						</span>
					</router-link>
				</div>
			</Slick>
			<div class="fade-side"></div>
			<div class="m_filter_btn">
				<a
					href="javascript:void(0);"
					@click.prevent="
						$modal.show('m-filters', {
							organic: false,
							veganp: false,
							gluten: false,
							sale: false,
							red: false,
							white: false,
							roze: false
						})
					"
				>
					<filter-svg></filter-svg>סינון
				</a>
			</div>
		</div>
		<section class="inner_page">
			<div class="container">
				<breadcrumbs :top="mainCategory" :sub="subCategory"></breadcrumbs>

				<div class="cat_inner row clearfix">
					<div class="right side col-sm-2 col-xs-12">
						<div class="side_wrap">
							<div class="side_nav">
								<div class="side_title">
									{{ mainCategory.name }}
								</div>
								<div
									class="side_nav_link ease"
									v-bind:class="{
										active: subcat.id === subCategory.id
									}"
									:data-category_id="subcat.id"
									v-for="subcat in subCategories"
									:key="subcat.id"
								>
									<router-link v-if="false" :to="{ path: subcat.link }">
										{{ subcat.name }}
									</router-link>
									<a
										href="javascript:void(0)"
										v-bind:data-subid="subcat.id"
										@click="scrollToCategory($event, subcat.id)"
									>
										{{ subcat.name }}
									</a>
								</div>
							</div>
							<div class="side_filters">
								<div class="side_title">סינון לפי:</div>

								<!-- zzz html -->
								<template v-for="filter in $store.state.productFilters" v-key="filter.name">
									<div
										v-if="
											filter.category_ids.includes(mainCategory.id) || filter.category_ids === '*'
										"
										class="filter_check"
										:class="{ active: filter.isActive }"
									>
										<a
											href="javascript:void(0);"
											@click.prevent="$store.commit('toggleProductFilter', filter.name)"
										>
											{{ filter.name }}
											<img
												v-if="filter.image"
												:id="filter.image.id"
												:src="filter.image.src"
												:alt="filter.image.alt"
											/>
										</a>
									</div>
								</template>

								<div class="filter_clean">
									<a href="javascript:void(0);" @click.prevent="$store.commit('clearProductFilters')"
										>ביטול סינונים</a
									>
								</div>
							</div>
						</div>
					</div>
					<div class="left main col-sm-10 col-xs-12">
						<div
							class="mainLoader"
							style="position: absolute; top: 50px; right: 50%; width: 150px; margin-right: -75px"
						>
							<img style="max-width: 100%" :src="loaderGif" />
						</div>
						<div
							class="subcat_with_items"
							v-inview:enter="onEnterCategory"
							v-if="categoriesToShow[category.id]"
							v-for="(category, indexCat) in subCategories"
							v-bind:index="indexCat"
							:data-category_id="category.id"
							:key="category.id"
							:name="category.name"
						>
							<div class="m_row">
								<h1 class="cat_title">{{ category.name }}</h1>
								<span
									class="cat_subtitle"
									v-if="typeof category.subtitle != 'undefined' && category.subtitle"
								>
									{{ category.subtitle }}
									<template v-for="tag in category.tags">
										<div
											class="pod_icon no-gluten"
											style="position: relative; top: -3px; left: -10px; margin-left: 5px"
											:class="{
												'no-gluten': tag.value == 'glutenfree',
												organic: tag.value == 'organic'
											}"
										>
											{{ tag.label }}
										</div>
									</template>
								</span>
								<banner-logo :sale="category.sale" v-if="category.sale" />
							</div>
							<div class="category_inner_prods row" :class="productsView">
								<ProductRow
									:category="category"
									:items="getProducts(category.id)"
									:showAllProducts="showAllProducts[category.id]"
									:numofproducts="productsToShow[category.id]"
									:index="indexCat"
									:allPageLoaded="allPageLoaded"
									:inlinePromotions="getInlinePromotions(category.id)"
								></ProductRow>
								<span
									:data-category_id="category.id"
									style="display: block; height: 1px"
									v-inview:enter="onCategoryEnd"
								></span>
								<div
									class="loader"
									v-if="!showAllProducts[category.id] && productsLoaders[category.id]"
								>
									<img :src="loaderGif" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import Product from "../components/Product/Product";
	import BannerLogo from "../components/Banners/Sale";
	import FilterSvg from "../assets/img/filters.svg";
  import {mapGetters, mapState} from "vuex";
	import Breadcrumbs from "../components/Breadcrumbs";
	import MobileFilters from "../components/Popups/FilterMobilePopup";
	import ProductRow from "../components/ProductsRow";
	import Slick from "vue-slick";
	export default {
		metaInfo() {
			return {
				title: this.subCategory.yoast_title ? this.subCategory.yoast_title : this.subCategory.name
				//  meta: [
				//     { vmid: 'description', name: 'description', content: this.subCategory.description }
				//   ]
				// titleTemplate: '%s - כרמלה'
			};
		},
		data() {
			return {
				assets: wpData.assets_url,
				home_url: wpData.home_url,
				globalOptions: wpData.globalOptions,
				showLoader: false,
				perPage: 20,
				allProducts: {},
				pageLoaded: false,
				allPageLoaded: false,
				shownumproducts: 20,
				productsToShow: {},
				showAllProducts: {},
				productsLoaders: {},
				categoriesToShow: {},
				categoryFirstLoad: true,
				stopLoad: false,
				firstloop: true,
				categoryIndex: 0,
				loaderGif: wpData.assets_url + "/layout/loader.gif",
				loaded: false,
				fromPopup: false,
				mSlickOptions: {
					arrows: false,
					rtl: true,
					dots: false,
					infinite: false,
					speed: 300,
					centerMode: false,
					initialSlide: 0,
					slidesToShow: 2,
					variableWidth: true,
					slidesToScroll: 1,
          cssEase: 'linear',
          draggable: true, // Allow dragging
          swipe: true, // Enable swipe
          touchMove: true, // Enable touch movement
				},
				lastSentFilters: null,
				inlinePromotions: [
					{
						title: "קידום ראשון",
						text: "זה הטקסט שלו",
						cta: "הנעה לפעולה",
						link: "#1",
						imageTall: "#0",
						imageWide: "#0"
					},
					{
						title: "קידום שני",
						text: "זה הטקסט שלו שני",
						cta: "הנעה לפעולה שניה",
						link: "#2",
						imageTall: "#0",
						imageWide: "#0"
					}
				]
			};
		},
		updated() {
      this.$nextTick(() => {
        this.$refs.slick.create();
      });

      setTimeout(() => {
        $('.m_cat_tabs').addClass('nav-down');
        $(".mainLoader").hide();
      }, 200);

      setTimeout(() => {
        let indexOfSlide = this.subCategories.indexOf(this.subCategory);
        this.$refs.slick.goTo(indexOfSlide);
      }, 200);

			if ($(".side_wrap:visible").length > 0) {
				let topHeight = $("#header").outerHeight() + 50;
				let bottomHeight = $(".footer").outerHeight() + 50;
				$(".side_wrap").sticky({
					topSpacing: topHeight,
					bottomSpacing: bottomHeight
				});
			}
		},
    mounted() {
      this.$root.$on("openPop", () => {
        this.fromPopup = true;
      });

      this.$nextTick(() => {
        if (this.$refs.slick) {
          let indexOfSlide = this.subCategories.indexOf(this.subCategory);
          this.$refs.slick.goTo(indexOfSlide);
        }
      });

      setTimeout(() => {
        $(".mainLoader").hide();
        $('.m_cat_tabs').addClass('nav-down');
      }, 200);

      console.log(this.subCategory);

      window.addEventListener('scroll', e => {
        const slick = this.$refs.slick;
        let offset = 400;
        let inViewElement = null;

        $('.subcat_with_items').each(function() {
          const elementTop = $(this).offset().top;
          const elementBottom = elementTop + $(this).outerHeight();
          const viewportTop = $(window).scrollTop();
          const viewportBottom = viewportTop + $(window).height() - offset;

          // Check if the element is in the viewport
          if (elementBottom > viewportTop && elementTop < viewportBottom) {
            inViewElement = $(this); // Element is in view
          }
        });

        if (inViewElement) {
          let indexOfSlide = inViewElement.attr('index');
          console.log('Element in view:', indexOfSlide);
          slick.goTo(indexOfSlide);
          $('.m_cat_tab.active').removeClass('active');
          $('.m_cat_tabs .slick-slide[data-slick-index="'+indexOfSlide+'"] .m_cat_tab').addClass('active');
        }
      });

      // if ($(window).width() <= 800) {
      //   $(".m_cat_tabs").after("<div class='m_cat_tabs_position hide'></div>");
      //   window.didScroll;
      //   window.lastScrollTop = 0;
      //   window.delta = 5;
      //   window.navbarHeight = $(".m_cat_tabs").outerHeight();
      //   window.scrollStartFrom = $(".m_cat_tabs").outerHeight() + $("#header").outerHeight() + 170 - 36;
      //
      //   $(document).ready(function(){
      //     window.addEventListener('scroll', function(e) {
      //       if ($(".m_cat_tabs").length == 0) {
      //         return;
      //       }
      //       var st = $(this).scrollTop();
      //       // Make sure they scroll more than window.delta
      //       if (Math.abs(window.lastScrollTop - st) <= window.delta) {
      //         // $(".m_cat_tabs_position").addClass("hide");
      //         // $('.m_cat_tabs').removeClass('nav-down').removeClass('nav-up');
      //         // return;
      //       }
      //       if (st <= window.scrollStartFrom) {
      //         $(".m_cat_tabs_position").addClass("hide");
      //         $('.m_cat_tabs').removeClass('nav-down').removeClass('nav-up');
      //         return;
      //       }
      //
      //       // If they scrolled down and are past the navbar, add class .nav-up.
      //       // This is necessary so you never see what is "behind" the navbar.
      //       if (st > window.lastScrollTop && st > window.navbarHeight) {
      //         // Scroll Down
      //         $(".m_cat_tabs_position").removeClass("hide");
      //         $('.m_cat_tabs').removeClass('nav-down').addClass('nav-up');
      //       } else {
      //         // Scroll Up
      //         if ($(this).scrollTop() >= st) {
      //           $(".m_cat_tabs_position").removeClass("hide");
      //           $('.m_cat_tabs').removeClass('nav-up').addClass('nav-down');
      //         }
      //       }
      //
      //       window.lastScrollTop = st;
      //     });
      //   })
      // }

      this.$root.$on("nextCategory", activeCategory => {
        let activeIndex = activeCategory.index + 1;
        let show = this.subCategories[activeIndex];
        if (typeof show != "undefined" && show) {
          this.categoriesToShow[show.id] = true;
        }
        this.subCategories.forEach((cat, index) => {
          if (index < activeIndex && !this.categoriesToShow[cat.id]) {
            this.categoriesToShow[cat.id] = true;
          }
        });
        if (false && activeIndex >= this.subCategories.length && this.$route.name == "subcategory") {
          if (!this.categoriesToShow[this.subCategories[0].id]) {
            this.categoriesToShow[this.subCategories[0].id] = true;
            let cat_id = this.subCategories[0].id;
          }
        }
      });
      setTimeout(() => {
        if ($(".side_wrap:visible").length > 0) {
          let topHeight = $("#header").outerHeight() + 50;
          let bottomHeight = $(".footer").outerHeight() + 50;
          $(".side_wrap").sticky({
            topSpacing: topHeight,
            bottomSpacing: bottomHeight
          });
        }
      }, 1000);
    },
    watch: {
			$route(to, from) {
				if (to.params.cat != from.params.cat) {
					this.$store.commit("clearProductFilters");
					this.lastSentFilters = null;
				}
				if (!this.fromPopup) {
					this.categoriesToShow = {};
				}
				this.fromPopup = false;
				$("#app").removeClass("cat-black");
			},
			subCategory(cat) {
				if (!this.categoryFirstLoad) {
					if (typeof this.$route.params.subcat != "undefined" && this.$route.params.subcat) {
						this.stopLoad = true;
						setTimeout(() => {
							this.stopLoad = false;
						}, 100);
					}
				}
			},
		},
		created() {
			window.addEventListener("scroll", this.infiniteScroll);
		},
		destroyed() {
			window.removeEventListener("scroll", this.infiniteScroll);
		},
		beforeRouteUpdate(to, from, next) {
			this.shownumproducts = 20;
			this.perPage = 20;
			this.allProducts = [];
			this.categoryIndex = 0;
			$(".mainLoader").show();

      if (from.params.cat !== to.params.cat) {
        if (this.$refs.slick) {
          this.$refs.slick.destroy();
        }
      }

			next();
		},
		computed: {
			...mapGetters(["productsByCat", "categoriesBySlug"]),
      ...mapState([ "productsView"]),
			activeFilters() {
				return this.$store.state.productFilters.reduce((activeFilters, filter) => {
					if (filter.isActive) {
						return [...activeFilters, filter.name];
					} else {
						return activeFilters;
					}
				}, []);
			},
			mainCategory: function() {
				let slug = encodeURI(this.$route.params.cat).toLowerCase();
				var category = this.categoriesBySlug[slug];
				if (category) {
					if (category.is_black) {
						$("#app").addClass("cat-black");
					} else {
						$("#app").removeClass("cat-black");
					}
					return category;
				}
				return false;
			},
			subCategory: function() {
				// console.log(this.$route.params.subcat.replace(/-/g, " "));

				let slug = this.$route.params.subcat
					? encodeURI(this.$route.params.subcat).toLowerCase()
					: encodeURI(this.$route.params.cat).toLowerCase();
				var category = this.categoriesBySlug[slug];

				if (category) {
					if (this.$route.name === "subcategory") {
						//this.categoriesToShow[category.id] = true;
						this.categoryFirstLoad = false;
					}
					return category;
				}
				if (this.$route.name == "category") {
					if (this.subCategories.length > 0) {
						let cat = this.subCategories[0];
						this.categoriesToShow[cat.id] = true;
						return this.subCategories[0];
					}
				}
				return false;
			},
			subCategories: function() {
				var subcat = this.$store.state.categories.filter(cat => {
					return cat.parent === this.mainCategory.id;
				});

				if (subcat) {
					subcat.map(cat => {
						this.initCategory(cat.id);
					});

					if (this.$route.name == "subcategory") {
						let indexOfCat = subcat.indexOf(this.subCategory);
						subcat.forEach((cat, index) => {
							if (index < indexOfCat) {
								this.showAllProducts[cat.id] = true;
								this.categoriesToShow[cat.id] = true;
							}
						});
						this.categoriesToShow[this.subCategory.id] = true;

            setTimeout(() => {
							this.stopLoad = true;
							$("html,body").animate(
								{
									scrollTop:
										$(".subcat_with_items[data-category_id=" + this.subCategory.id + "]").offset()
											.top - 120
								},
								0
							);
						}, 200);
					}

					if (this.$route.name == "category") {
						this.categoriesToShow[subcat[0].id] = true;
					}

					return subcat;
				}

				return false;
			},
			products: function() {
				let slug = encodeURI(this.$route.params.subcat).toLowerCase();
				return;
			},
			productsLength: function() {
				if (typeof this.filteredList(this.products) != "undefined") {
					return this.filteredList(this.products).length;
				}
				return 0;
			}
		},
		methods: {
			getInlinePromotions(cat_id) {
				let inlinePromotions = wpData.inlinePromotions;
				return wpData.inlinePromotions.filter(o => o.subcategory_id === cat_id);
			},

			scrollToCategory(e, id) {
				$(".side_nav_link").removeClass("active");
				let cat_id = $(e.target)
					.closest(".side_nav_link")
					.attr("data-category_id");
				let breakLoop = false;
				this.subCategories.forEach((cat, index) => {
					if (cat.id != cat_id && !breakLoop) {
						this.showAllProducts[cat.id] = true;
						this.categoriesToShow[cat.id] = true;
					} else {
						breakLoop = true;
					}
				});

				this.categoriesToShow[cat_id] = true;
				$(e.target)
					.closest(".side_nav_link")
					.addClass("active");
				this.stopLoad = true;
				setTimeout(() => {
					$("html,body").animate(
						{
							scrollTop: $(".subcat_with_items[data-category_id=" + id + "]").offset().top - 150
						},
						0,
						() => {}
					);
				}, 100);
			},
			onCategoryEnd(element) {
				if (!this.pageLoaded) return;
				if (this.stopLoad) {
					return;
				}
				let category_id = element.dataset.category_id;
				let prev = $(element).closest(".subcat_with_items");
				if (prev.is(".subcat_with_items")) {
					let id = prev.attr("data-category_id");
					if (!this.getProducts(id)) {
						this.productsLoaders[id] = false;
						return;
					}

					this.productsLoaders[id] = true;
					if (
						(typeof this.getProducts(id) != "undefined" &&
							this.productsToShow[id] < this.getProducts(id).length) ||
						this.getProducts(id).length < 20
					) {
						setTimeout(() => {
							this.productsToShow[id] += 20;
							this.productsLoaders[id] = false;
						}, 500);
					} else {
						this.productsLoaders[id] = false;
					}
				}
				//console.log($(element)[0].previousElementSibling);

				$(".side_nav_link").removeClass("active");
				$(".side_nav_link[data-category_id=" + category_id + "]").addClass("active");
			},
			onEnterCategory(element) {
				if (!this.pageLoaded) return;
				if (this.stopLoad) {
					return;
				}
				let category_id = element.dataset.category_id;
				let prev = $(element).prev();
				if (prev.is(".subcat_with_items")) {
					let id = prev.attr("data-category_id");
					if (!this.getProducts(id)) {
						this.productsLoaders[id] = false;
						return;
					}

					this.productsLoaders[id] = true;
					if (
						typeof this.getProducts(id) != "undefined" &&
						this.productsToShow[id] < this.getProducts(id).length
					) {
						setTimeout(() => {
							this.productsToShow[id] += 20;
							this.productsLoaders[id] = false;
						}, 1000);
					} else {
						this.productsLoaders[id] = false;
					}
				}
				//console.log($(element)[0].previousElementSibling);

				$(".side_nav_link").removeClass("active");
				$(".side_nav_link[data-category_id=" + category_id + "]").addClass("active");
			},
			getProducts(category_id) {
				// If currently active filters are different than last sent to ga filters"
				if (
					this.activeFilters.length &&
					JSON.stringify(this.activeFilters) != JSON.stringify(this.lastSentFilters) &&
					typeof dataLayer !== "undefined"
				) {
					dataLayer.push({
						event: "ga_event",
						category: "Shop",
						action: "Filters",
						label: this.activeFilters.join(" + ")
					});
					this.lastSentFilters = this.activeFilters;
				}

				let slug = encodeURI(this.$route.params.subcat).toLowerCase();

				//var productsFound = this.productsByCat[category_id];
				var productsFound = this.allProducts[category_id];
				return productsFound;
			},
			toggleLoader() {
				this.showLoader = false;
			},
			filteredList(items) {
				if (typeof items != "undefined" && items.length > 0) {
					return items.slice(0, parseInt(this.perPage));
				}
				return false;
			},
			showAllCategories() {
				this.subCategories.map(cat => {
					this.categoriesToShow[cat.id] = true;
				});
			},
			showMoreProducts() {
				if (this.productsLength < this.shownumproducts) {
					return false;
				}
				this.showLoader = true;

				setTimeout(() => {
					this.showLoader = false;
				}, 1000);
				this.perPage += 20;
				this.shownumproducts += 20;
			},
			infiniteScroll() {
				var footer = document.getElementsByTagName("footer");
				this.stopLoad = false;
				var scrollHeightTest = footer[0].offsetTop - footer[0].offsetHeight - 500;
				if (window.pageYOffset >= scrollHeightTest) {
					//this.showMoreProducts();
					//this.$root.$emit('scroll');
				}
			},

			initCategory(cat_id) {
				this.$set(this.productsToShow, cat_id, 20);
				this.$set(this.productsLoaders, cat_id, false);
				this.$set(this.categoriesToShow, cat_id, false);
				this.$set(this.showAllProducts, cat_id, false);
				this.allProducts[cat_id] = this.productsByCat[cat_id];

				this.pageLoaded = true;
			}
		},
		components: {
			Product,
			Breadcrumbs,
			BannerLogo,
			FilterSvg,
			Slick,
			MobileFilters,
			ProductRow
		}
	};
</script>
<style>
	.m_row {
		padding: 20px 0;
	}
	.cat_subtitle {
		color: red;
	}
	#vegan-friendly-icon {
		width: 1.5rem;
		transform: translateY(-0.3rem);
	}

	/* Katzavia black category specific styles */
	.cat-black .side_title {
		color: #bbb;
	}
	.cat-black .pop_filters_m .filter_check.active a {
		color: #ea4725;
	}
  .category_top_banner .white-text .title, .category_top_banner .white-text .text {
    color: #fff;
  }
</style>
<style scoped>
@media (min-width: 768px) {
  div#sticky-wrapper .side_wrap::-webkit-scrollbar {
    display: none;
  }

  div#sticky-wrapper.is-sticky .side_wrap[data-v-51cb8b16] {
    height: calc(100vh - 185px);
    overflow-y: scroll;
  }
}
</style>
